var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showWarning)?_c('v-alert',{attrs:{"text":"","outlined":"","color":"deep-orange"}},[_c('p',{key:_vm.countdownMessageKey},[_vm._v(_vm._s(_vm.countdownMessage))])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }